import { SuccessAlert, ErrorAlert } from "components/atoms/Alert"
import { Button, LinkButton } from "components/atoms/Button"
import { PageTitle } from "components/atoms/PageTitle"
import {
  AuthForm,
  AuthFormItem,
  FormEmailInputForReset,
} from "components/atoms/form"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useState } from "react"
import styled from "styled-components"
import { resetPassword, firebaseError } from "usecases/firebase/auth"

interface ResetEmailIF {
  email: string
}

const StyledForm = styled(AuthForm)`
  width: 720px;
`

export const ForgetPage: React.VFC = () => {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [sentEmailAddress, setSentEmailAddress] = useState("")
  const [errorCode, setErrorCode] = useState("")
  const [loading, asyncLoading] = useAsyncLoading()
  const onFinish = (values: unknown) => {
    asyncLoading(
      resetPassword((values as ResetEmailIF).email)
        .then(() => {
          setSentEmailAddress((values as ResetEmailIF).email)
          setSuccess(true)
        })
        .catch((e) => {
          setError(true)
          const mes = firebaseError(e.code, "reset")
          mes && setErrorCode(mes)
        }),
    )
  }

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo)
  }
  return (
    <StyledForm onFinish={onFinish} onFinishFailed={onFinishFailed}>
      <PageTitle>パスワード再発行</PageTitle>
      <AuthFormItem wrapperCol={{ offset: 4, span: 16 }}>
        登録したメールアドレス宛にパスワード再発行のメールを送信いたします。
        <br /> 送信されたメールに沿ってパスワードの再設定をお願いいたします。
      </AuthFormItem>
      <FormEmailInputForReset />
      {success && (
        <SuccessAlert>
          {sentEmailAddress} 宛に
          <br />
          パスワード再発行のメールを送信しました。
        </SuccessAlert>
      )}
      {error && !success && <ErrorAlert>{errorCode}</ErrorAlert>}
      <AuthFormItem>
        <Button isLoading={loading} className={"primary"} htmlType="submit">
          パスワードリセット
        </Button>
      </AuthFormItem>
      <LinkButton to="/">トップへ戻る</LinkButton>
    </StyledForm>
  )
}
